import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./style.module.css";
import Header from "../../partials/ExternalHeader";
import CalDel from "../../../images/cal-del.png";
import { useSelector, useDispatch } from "react-redux";
import { loginSuccess, logout } from "../../Redux/Authentication";
import { Link, useNavigate, useParams } from "react-router-dom";
import { notification } from "antd";
import { Html5QrcodeScanner, Html5Qrcode } from "html5-qrcode";
import _ from "lodash";
const url = process.env.REACT_APP_APP_BACK_URL;
const streaming_url = process.env.REACT_APP_STREAMIN_SOCKET_URL;
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const AdminPin = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  let { slug } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [code, setCode] = useState("");
  const [isFloating, setIsFloating] = useState(false);
  const [isCallFloating, setIsCallFloating] = useState(false);
  const [displayscaner, setdisplayscaner] = useState(false);
  const [modalIsOpen1, setIsOpen1] = useState(false);
  const [scannerInitialized, setScannerInitialized] = useState(false);
  const [authenticationFailed, setAuthenticationFailed] = useState(false);

  const idleTimer = useRef(null);
  const lastActivityTime = useRef(Date.now());
  let idleTimeoutInSeconds = 15; // 5 minutes (adjust as needed)
  const handle_logout = useCallback(async () => {
    await localStorage.removeItem("token");
    dispatch(logout());

    const siteuser = localStorage.getItem("siteuser");
    if (siteuser) {
      navigate(`/${siteuser}/pin`);
    } else {
      const siteUserSessions = sessionStorage.getItem("siteuser");
      navigate(`/${siteUserSessions}/pin`);
    }
  }, [dispatch, navigate]);

  const resetIdleTimer = useCallback(() => {
    lastActivityTime.current = Date.now();
  }, []);

  useEffect(() => {
    getTimer();
    // Debounced activity handler
    const onActivity = _.debounce(() => {
      resetIdleTimer();
    }, 300);

    // Register event listeners for user activity
    const activityEvents = ["mousemove", "keydown", "mousedown", "scroll"];
    activityEvents.forEach((event) => {
      window.addEventListener(event, onActivity);
    });

    // Set up an interval to check for idle state every second
    idleTimer.current = setInterval(() => {
      if (Date.now() - lastActivityTime.current > idleTimeoutInSeconds * 1000) {
        handle_logout();
      }
    }, 1000);

    // Cleanup function
    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, onActivity);
      });
      onActivity.cancel(); // Cancel debounce to prevent memory leaks
      clearInterval(idleTimer.current); // Clear interval on unmount
    };
  }, [handle_logout, resetIdleTimer]);

  const getTimer = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      const response = await fetch(`${url}/api/timeout/getByType/PickUps`, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      idleTimeoutInSeconds = json.data?.time;
    } catch (error) {
      console.error(error);
    }
  };
  const handleInput = (e) => {
    setCode((prevCode) => e.target.value);
  };
  const [barcode, setBarcode] = useState("");
  const codeInputRef = useRef(null);
  let scanner;
  useEffect(() => {
    let html5QrCode;
    if (!scannerInitialized && modalIsOpen1) {
      html5QrCode = new Html5Qrcode("reader");
      html5QrCode
        .start(
          {
            fps: 5,
            qrbox: { width: 200, height: 200 },
          },
          success,
          error
        )
        .catch((err) => {
          console.error("Error starting scanner: ", err);
        });
      setScannerInitialized(true);
    }
    function success(result) {
      console.log("===result==", result);
      scanner.clear();
      // setIsLoading(true);
      formSubmit1(result);
    }
    function error(err) {
      console.warn(err);
    }
    return () => {
      if (scannerInitialized) {
        // scanner.clear();
        setScannerInitialized(false);
      }
    };
  }, [scannerInitialized, modalIsOpen1]);
  useEffect(() => {
    if (authenticationFailed) {
      // Reinitialize the scanner if authentication fails
      setScannerInitialized(false);
      setAuthenticationFailed(false);
      setdisplayscaner(false);
    }
  }, [authenticationFailed]);

  // Focus the visible code input field on mount
  useEffect(() => {
    if (codeInputRef.current) {
      codeInputRef.current.focus();
    }
  }, []);
  useEffect(() => {
    let interval;
    const handleKeyDown = (evt) => {
      if (interval) clearInterval(interval);
      if (evt.code === "Enter") {
        if (code) formSubmit();
        setBarcode("");
        return;
      }
      if (evt.key !== "Shift")
        setBarcode((prevBarcode) => prevBarcode + evt.key);
      interval = setInterval(() => setBarcode(""), 20);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [code]);
  const handleDigitClick = (digit) => {
    setCode((prevCode) => prevCode + digit);
  };
  const handleDeleteDigit = () => {
    setCode((prevCode) => prevCode.slice(0, -1));
  };
  // const formSubmit = async () => {
  //   // navigate(`/${slug}/dashboard`);
  //   notification.success({
  //     message: "Success",
  //     description: "Locker Open successfully",
  //     duration: 3,
  //   });
  //   setCode("");
  // };
  // const formSubmit = async () => {
  //   try {
  //     let headers = new Headers();
  //     headers.append("Content-Type", "application/json");
  //     headers.append("Access-Control-Allow-Origin", "*");
  //     headers.append("Access-Control-Allow-Credentials", "true");
  //     setIsLoading(true);
  //     const response = await fetch(`${url}/api/sites/open/locker`, {
  //       mode: "cors",
  //       method: "POST",
  //       headers: headers,
  //       body: JSON.stringify({
  //         name: code,
  //         slug: slug,
  //       }),
  //     });
  //     setIsLoading(false);
  //     const json = await response.json();
  //     if (json.success) {
  //       notification.success({
  //         message: "Success",
  //         description: json.message,
  //         duration: 3,
  //       });
  //     } else {
  //       notification.error({
  //         message: "Errorr",
  //         description: json.message,
  //         duration: 3,
  //       });
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //     notification.error({
  //       message: "Errorr",
  //       description: error.message,
  //       duration: 3,
  //     });
  //   }
  // };

  const redirectAfterPinLogin = (user) => {
    if (slug) {
      localStorage.setItem("siteuser", slug);
    }
    if (user.role === "admin" || user.role === "staff") {
      navigate("/pickup/add");
    } else {
      navigate("/dashboard");
    }
  };

  const formSubmit1 = async (qrCode) => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      setIsLoading(true);
      const response = await fetch(
        `${url}/api/auth/checkUserPin/${encodeURIComponent(
          qrCode
        )}?slug=${encodeURIComponent(slug || "")}`,
        {
        mode: "cors",
        method: "GET",
        headers: headers,
      });
      const json = await response.json();

      setIsLoading(false);
      if (json.success) {
        const user = json.user;
        const expirationTime = Math.floor(Date.now() / 1000) + 7200;
        localStorage.setItem("token", json.authToken);
        localStorage.setItem("token-expiration", expirationTime);
        localStorage.setItem("loggedIn", true);
        // socket.emit("login", json.user._id);
        dispatch(loginSuccess(json.user));
        redirectAfterPinLogin(user);
        // notification.success({
        //   message: "Success",
        //   description: "Login Successfully",
        //   duration: 3,
        // });
      } else {
        notification.error({
          message: "Failed",
          description: json.error,
          duration: 3,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.error({
        message: "Error",
        description: error.message,
        duration: 3,
      });
    }
  };
  const formSubmit = async () => {
    try {
      if (!String(code || "").trim()) {
        notification.error({
          message: "PIN required",
          description: "Enter your PIN to continue.",
          duration: 3,
        });
        return;
      }
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      setIsLoading(true);
      const response = await fetch(
        `${url}/api/auth/checkUserPin/${encodeURIComponent(
          code.trim()
        )}?slug=${encodeURIComponent(slug || "")}`,
        {
        mode: "cors",
        method: "GET",
        headers: headers,
      });
      const json = await response.json();

      setIsLoading(false);
      if (json.success) {
        const user = json.user;
        const expirationTime = Math.floor(Date.now() / 1000) + 7200;
        localStorage.setItem("token", json.authToken);
        localStorage.setItem("token-expiration", expirationTime);
        localStorage.setItem("loggedIn", true);
        // socket.emit("login", json.user._id);
        dispatch(loginSuccess(json.user));
        redirectAfterPinLogin(user);
        // notification.success({
        //   message: "Success",
        //   description: "Login Successfully",
        //   duration: 3,
        // });
      } else {
        notification.error({
          message: "Failed",
          description: json.error,
          duration: 3,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.error({
        message: "Error",
        description: error.message,
        duration: 3,
      });
    }
  };
  const iocnStyle = {
    display: isLoading ? "inline-block" : "none",
  };

  const handleVideoClick = () => {
    const { width } = getWindowDimensions();
    const surfaceTabletWidth = 768;
    if (width < surfaceTabletWidth) {
      setIsFloating(!isFloating);
      setIsCallFloating(false);
    } else {
      setIsFloating(false);
    }
  };
  const handleButton1 = async () => {
    setdisplayscaner(true);
    setIsOpen1(true);
  };
  function closeModal() {
    setIsOpen1(false);
    setAuthenticationFailed(true);
  }

  const readerStyle = {
    position: "relative",
    marginTop: "20px",
    marginBottom: "20px",
    overflowY: "auto", // Enable scrolling if content exceeds height on large screens
  };

  // Define the CSS classes based on the isActive state
  const divClassName = isActive ? "sidebar active" : "sidebar";
  return (
    <div className={styles.heading}>
      <div className="body-wrap">
        <div className="container-fluid px-0">
          <Header />
          {/* <div className=" w-100 d-flex justify-content-center mt-3 mb-lg-5">
            <div
              style={{ width: "50%", borderRadius: 20 }}
              className=" bg-white p-3 shadow-lg"
            ></div> */}
          {/* </div> */}

          <div className=" w-100 d-flex justify-content-center mt-5">
            {/* <div className="mt-5 mb-3">
              {isLoading ? (
                <div className="text-center">
                  <h3>Loading....</h3>
                </div>
              ) : (
                displayscaner && (
                  <div
                    id="reader"
                    style={readerStyle}
                    className="render-class"
                  ></div>
                )
              )}
              {!modalIsOpen1 ? (
                <button
                  className="btn btn-prim w-auto py-3"
                  onClick={handleButton1}
                >
                  Scan QR Code
                </button>
              ) : (
                <div className=" d-flex w-100 justify-content-center align-items-center">
                  <button
                    className="btn btn-prim w-auto py-3"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              )}
            </div> */}
          </div>
          <div className={styles.body_wrap}>
            <div className="mt-5">
              <div className="calc-wrap-main">
                <div className="row text-center">
                  <div className="col-lg-12">
                    <div className="calc-wrap">
                      <div className="cal-screen">
                        <input
                          type="number"
                          id="result"
                          ref={codeInputRef}
                          onChange={handleInput}
                          value={code}
                          placeholder="Enter Pin"
                          autoFocus
                        />
                      </div>
                      <div className="keys-wrap">
                        <div className="row ">
                          <div className="col-4">
                            <button
                              className="btn-key"
                              onClick={() => handleDigitClick("1")}
                            >
                              <i>1</i>
                            </button>
                          </div>
                          <div className="col-4">
                            <button
                              className="btn-key"
                              onClick={() => handleDigitClick("2")}
                            >
                              <i>2</i> <span>ABC</span>
                            </button>
                          </div>
                          <div className="col-4">
                            <button
                              className="btn-key"
                              onClick={() => handleDigitClick("3")}
                            >
                              <i>3</i> <span>DEF</span>
                            </button>
                          </div>
                          <div className="col-4">
                            <button
                              className="btn-key"
                              onClick={() => handleDigitClick("4")}
                            >
                              <i>4</i> <span>GHI</span>
                            </button>
                          </div>
                          <div className="col-4">
                            <button
                              className="btn-key"
                              onClick={() => handleDigitClick("5")}
                            >
                              <i>5</i> <span>JKL</span>
                            </button>
                          </div>
                          <div className="col-4">
                            <button
                              className="btn-key"
                              onClick={() => handleDigitClick("6")}
                            >
                              <i>6</i> <span>MNO</span>
                            </button>
                          </div>
                          <div className="col-4">
                            <button
                              className="btn-key"
                              onClick={() => handleDigitClick("7")}
                            >
                              <i>7</i> <span>PQRS</span>
                            </button>
                          </div>
                          <div className="col-4">
                            <button
                              className="btn-key"
                              onClick={() => handleDigitClick("8")}
                            >
                              <i>8</i> <span>TUV</span>
                            </button>
                          </div>
                          <div className="col-4">
                            <button
                              className="btn-key"
                              onClick={() => handleDigitClick("9")}
                            >
                              <i>9</i> <span>WXYZ</span>
                            </button>
                          </div>
                          <div className="col-4">
                            <div className="empty-div-cal"></div>
                          </div>

                          <div className="col-4">
                            <button
                              className="btn-key"
                              onClick={() => handleDigitClick("0")}
                            >
                              <i>0</i>
                            </button>
                          </div>
                          <div className="col-4">
                            <button
                              className="btn-delt"
                              onClick={handleDeleteDigit}
                            >
                              <img src={CalDel} alt="" />{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="cont-btn-wrap">
                        <button
                          className="continue-btn"
                          disabled={isLoading}
                          onClick={formSubmit}
                        >
                          <i
                            className="fa fa-spinner fa-spin"
                            style={iocnStyle}
                          ></i>{" "}
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPin;
